import React from 'react'
import { RewindIcon } from '@mote/assets/icons'
import type { CommonButtonProps } from './Common'
import { CommonButton } from './Common'

export interface RewindButtonProps extends Pick<CommonButtonProps, 'onClick'> {}

export function RewindButton(props: RewindButtonProps): JSX.Element {
  return (
    <CommonButton
      ariaLabel={'rewind'}
      id={'mote-player-rewind-button'}
      text={'Back 5 sec (j)'}
      onClick={props.onClick}
    >
      <RewindIcon />
    </CommonButton>
  )
}
